import {
  alpha,
  styled,
  Typography,
  TypographyProps,
} from '@mui/material';
import { spaceCadet } from '../../../../../../../../../../utils/colors';

interface StyledTypographyProps extends TypographyProps {
  color?: string;
}

const StyledTypography = styled((props: StyledTypographyProps) => {
  const { color, ...other } = props;
  return (
    <Typography {...other} />
  );
})(({ color }) => ({
  display: 'flex',
  gap: 4,
  alignItems: 'center',
  '& svg': {
    fontSize: 12,
    display: 'block',
  },
  color: color ?? spaceCadet[500],
  backgroundColor: color ? alpha(color, 0.1) : spaceCadet[100],
  margin: 0,
  fontSize: 10,
  borderRadius: 4,
  lineHeight: '16px',
  padding: '2px 8px',
  fontWeight: 600,
  width: 'max-content',
  textTransform: 'uppercase',

}));

export default StyledTypography;
